import { render, staticRenderFns } from "./DraftEventReview.vue?vue&type=template&id=3916259c&"
import script from "./DraftEventReview.vue?vue&type=script&lang=js&"
export * from "./DraftEventReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports